import { Model } from '@vuex-orm/core'
import shortid from 'shortid'
import _ from 'lodash'
import Device from "./Device";

export default class Location extends Model {
    static entity = 'locations'
    static fields() {
        return {
            id: this.attr(shortid.generate()),
            deviceId: this.attr(null),
            device: this.belongsTo(Device,'deviceId'),
            lat: this.attr(null),
            lng: this.attr(null),
            speed: this.attr(null),
            heading: this.attr(null),
            accuracy: this.attr(null),
            altitude: this.attr(null),
            altitudeAccuracy: this.attr(null),
            event: this.attr(null),
            odometer: this.attr(null),
            activityType: this.attr(null),
            activityConfidence: this.attr(null),
            batteryLevel: this.attr(null),
            batteryIsCharging: this.attr(null),
            isMoving: this.attr(null),
            dateGenerated: this.attr(null),
            dateCreated: this.attr(null),
        }
    }
}